  <template>
      <div>  

      <!------ Camera toggle made by TING ---------->
     <div class="menu">
        <label class="switch">
            <!-- <input type="checkbox" id="camera"  > -->
            <!-- <input type="checkbox" id="jack" value="Jack" v-model="checkedNames"> -->
            <input 
              type="checkbox" 
              id="checkbox" 
              v-model="cameraChecked" 
              @change="cameraToggle($event)"
              :disabled='cameraButtonDisabled'
            >

            <span class="slider"></span>
        </label> {{cameraMessage}}
        
      </div>

      <div id="video_container">
        <div :key="reRenderLocal">
          <div
            v-for="(track, t_index) in roomConnection.localParticipant.videoTracks"
            :key="track.key"
          >
            
              <Videotrack
                :participantkey="'you'"
                :publication="track"
                :trackindex="t_index"
              />

          </div>
        </div>

      </div>

  </div>
</template>

<script>
import Twilio, {
  connect,
  createLocalTracks,
  createLocalVideoTrack,
  createLocalAudioTrack,
} from "twilio-video"

import Videotrack from "../Videotrack"


export default {

  props: ["roomConnection","loading","cameraOptions","reRenderRoom"],

  components:{
    Videotrack
  },

  data: function(){
    return{
      cameraButtonDisabled:false,
      localCamera: null,
      localIndex: 0,
      reRenderLocal: 0,
      isCameraOn: false,
      cameraMessage: "Turn on camera",
      reRender:0,
      reRenderRemote:0,
      cameraChecked:false,

    }
  },

  created: function(){
    console.log('hi')
  },


  beforeDestroy: function() {
    if(this.localCamera != null){
      this.turnOffCamera();
    }
  },


  methods: {
    cameraToggle(e){
      this.cameraButtonDisabled = true;

      if(this.cameraChecked){
        this.turnOnCamera();
      }else{
        this.turnOffCamera();
      }
    },

    turnOnCamera(e) {
      const VueThis = this;
        if (VueThis.localCamera == null) {
          VueThis.cameraButtonDisabled = true;
          createLocalTracks({ audio: false, video: { deviceId: this.cameraOptions[0].deviceId } }).then((track) => {
            VueThis.localIndex += 1;
            VueThis.roomConnection.localParticipant.publishTrack(track[0]);
            VueThis.localCamera = track[0];
            setTimeout(function () {
              VueThis.reRenderLocal += 1;
              VueThis.reRender += 1;
              VueThis.cameraMessage = "Turn off camera";
              VueThis.isCameraOn  = true;
              VueThis.cameraButtonDisabled = false;
            }, 1000);
          });
        } else {
          this.turnOffCamera();
        }

        const videocontainer = document.getElementById('video_container');
        videocontainer.appendChild(this.$props.publication[1].track.attach());
        this.cameraButtonDisabled = false;

      },

      turnOffCamera() {
      
        const VueThis = this;
        VueThis.cameraMessage = "Turn on camera";
        VueThis.localCamera.stop();
        VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localCamera);
        VueThis.localCamera = null;
        VueThis.reRenderLocal += 1;
        VueThis.isCameraOn = false;

        this.cameraButtonDisabled = false;
      },
  },


  
}
</script>

<style>




</style>